import { render, staticRenderFns } from "./communityMiniList.vue?vue&type=template&id=336d9f58&scoped=true"
import script from "./communityMiniList.vue?vue&type=script&lang=js"
export * from "./communityMiniList.vue?vue&type=script&lang=js"
import style0 from "./communityMiniList.vue?vue&type=style&index=0&id=336d9f58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336d9f58",
  null
  
)

export default component.exports